export enum AlertDurationType {
    PERSIST_AFTER_EVENT = 'PERSIST_AFTER_EVENT',
    SCHEDULE_BEFORE_EVENT = 'SCHEDULE_BEFORE_EVENT'
}

export const alertDurationTypeDisplay = {
    [AlertDurationType.PERSIST_AFTER_EVENT]: 'Duration (days)',
    [AlertDurationType.SCHEDULE_BEFORE_EVENT]: 'Days before expiration'
};
